module.exports = __webpack_public_path__ + "img/header.75c8ce04.png";